import { useState } from 'react';
import { useForum } from '../useForum';
import { TextAreaField } from '@/components/forms';
import { glassCardStyle } from '@/components/auth/authStyles';
import { Send } from 'lucide-react';

interface CommentFormProps {
  postId: string;
  parentId?: string | null;
  onSuccess?: () => void;
  placeholder?: string;
}

export function CommentForm({ postId, parentId = null, onSuccess, placeholder = 'Share your perspective...' }: CommentFormProps) {
  const { createComment } = useForum();
  const [content, setContent] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim()) return;

    setSubmitting(true);
    try {
      createComment(postId, content, parentId);
      setContent('');
      onSuccess?.();
    } catch (error) {
      console.error('Failed to create comment:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-4 rounded-2xl p-4"
      style={glassCardStyle}
    >
      <TextAreaField
        label="Add a reply"
        value={content}
        onChange={setContent}
        rows={4}
        required
        placeholder={placeholder}
        className="resize-none"
      />
      <div className="flex justify-end">
        <button
          type="submit"
          disabled={!content.trim() || submitting}
          className="btn-electric inline-flex h-10 items-center justify-center gap-2 rounded-xl px-5 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-50"
        >
          {submitting ? 'Posting...' : 'Post Reply'}
          <Send size={14} />
        </button>
      </div>
    </form>
  );
}
